import {
    Box,
    Button, Grid,
    Hidden, useTheme
} from "@material-ui/core";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Typography from "@material-ui/core/Typography";
import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import pic1 from "../../assets/images/setUpMeetingDesc.png";
import { useStyles } from "../../components/common/MainStyles.jsx";
import { IsNullOrEmpty } from "../../helpers/utility";
import {
    deleteAllExistingProduct,
    getCategoryRequest
} from "../../store/shopping/shopping.actions";
import InstantRecording from "./instant_recording";
import InstantUpload from "./instant_upload";

export default function InstantVideo() {
    const dispatch = useDispatch();
    const location = useLocation();
    const classes = useStyles();
    const history = useNavigate();
    const theme = useTheme();
    const [mode, setMode] = useState("");
    const [selectedCategory, setSelectedCategory] = useState();

    useEffect(() => {
        if (location && location.hash) {
            setSelectedCategory(location.hash.replace("#", ""));
            if (location.hash.indexOf("Embed") > -1 || location.hash.indexOf("Uploading") > -1) {
                setMode("upload");
            }
            else {
                setMode("recording");
            }
        }
    }, [location])

    useEffect(() => {
        dispatch(getCategoryRequest());
        dispatch(deleteAllExistingProduct());
    }, []);

    return (
        <main className={classes.main}>
            <div className={classes.toolbar} />
            <Grid container className="h-full">
                <Grid item xs={12} sm={12} lg={mode !== "" ? 12 : 8} md={mode !== "" ? 12 : 8}>
                    {
                        mode === "" ? <Box display={"flex"} height="100%" flexDirection="column" justifyContent={"space-between"} className="my-4">
                            <Box className="mb-4">
                                <Typography
                                    variant="h5"
                                    component="p"
                                    className={classes.title}
                                >
                                    Choose video type
                                </Typography>
                                <Typography
                                    variant="p"
                                    component="p"
                                    className={classes.subTitle}
                                >
                                    Select the space you need for your video
                                </Typography>
                                <Grid container spacing={3} className="m-4 pt-4 pr-4">
                                    <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={6}
                                        lg={6}
                                    >
                                        <List
                                            className={clsx(
                                                classes.bgwhite,
                                                classes.borderRadius
                                            )}
                                            style={{
                                                border:
                                                    selectedCategory === "Recording"
                                                        ? "3px solid " +
                                                        theme.palette
                                                            .primary.main
                                                        : "1px solid #E1E1E1",
                                            }}
                                            onClick={() => {
                                                setSelectedCategory("Recording")
                                            }}
                                        >
                                            <ListItem>
                                                <Box width="100%" display={"flex"} flexDirection="column" justifyContent="space-between" alignItems={"center"}>
                                                    <svg width="61" height="61" viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M30.8905 40.535C35.1124 40.535 38.535 37.1124 38.535 32.8905C38.535 28.6686 35.1124 25.2461 30.8905 25.2461C26.6686 25.2461 23.2461 28.6686 23.2461 32.8905C23.2461 37.1124 26.6686 40.535 30.8905 40.535Z" fill="#7900F8" />
                                                        <path d="M23.7222 9L19.3506 13.7778H11.7778C9.15 13.7778 7 15.9278 7 18.5556V47.2222C7 49.85 9.15 52 11.7778 52H50C52.6278 52 54.7778 49.85 54.7778 47.2222V18.5556C54.7778 15.9278 52.6278 13.7778 50 13.7778H42.4272L38.0556 9H23.7222ZM30.8889 44.8333C24.2956 44.8333 18.9444 39.4822 18.9444 32.8889C18.9444 26.2956 24.2956 20.9444 30.8889 20.9444C37.4822 20.9444 42.8333 26.2956 42.8333 32.8889C42.8333 39.4822 37.4822 44.8333 30.8889 44.8333Z" fill="#7900F8" />
                                                    </svg>
                                                    <h4 className="title font-bold">Use Device Camera</h4>
                                                </Box>
                                            </ListItem>
                                        </List>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={6}
                                        lg={6}
                                    >
                                        <List
                                            className={clsx(
                                                classes.bgwhite,
                                                classes.borderRadius
                                            )}
                                            style={{
                                                border:
                                                    selectedCategory === "ScreenSharing"
                                                        ? "3px solid " +
                                                        theme.palette
                                                            .primary.main
                                                        : "1px solid #E1E1E1",
                                            }}
                                            onClick={() => {
                                                setSelectedCategory("ScreenSharing");
                                            }}
                                        >
                                            <ListItem>
                                                <Box width="100%" display={"flex"} flexDirection="column" justifyContent="space-between" alignItems={"center"}>
                                                    <svg width="61" height="61" viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <circle cx="30.4987" cy="30.5007" r="24.6667" stroke="#7900F8" stroke-width="1.5" />
                                                        <circle cx="30.5" cy="30.5" r="15.25" fill="#7900F8" />
                                                    </svg>
                                                    <h4 className="title font-bold">Screen recording</h4>
                                                </Box>
                                            </ListItem>
                                        </List>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={6}
                                        lg={6}
                                    >
                                        <List
                                            className={clsx(
                                                classes.bgwhite,
                                                classes.borderRadius
                                            )}
                                            style={{
                                                border:
                                                    selectedCategory === "Uploading"
                                                        ? "3px solid " +
                                                        theme.palette
                                                            .primary.main
                                                        : "1px solid #E1E1E1",
                                            }}
                                            onClick={() => {
                                                setSelectedCategory("Uploading")
                                            }}
                                        >
                                            <ListItem>
                                                <Box width="100%" display={"flex"} flexDirection="column" justifyContent="space-between" alignItems={"center"}>

                                                    <svg width="61" height="61" viewBox="0 0 61 61" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M3.90392 9.90366L3 10.8076V27.6393V44.4398L3.77924 45.2814L4.52732 46.0918H19.6447H34.7309L34.1075 44.2839C33.1412 41.541 33.3906 37.6136 34.6997 34.7772C37.2868 29.2601 43.2714 25.9873 48.9131 26.9847C49.9729 27.1717 51.095 27.4211 51.4067 27.5458C51.9054 27.764 51.9366 27.2341 51.9366 19.2858V10.8076L51.0327 9.90366L50.1287 8.99973H27.4683H4.80785L3.90392 9.90366ZM8.92226 13.0518V14.922H7.05207H5.18189V13.27C5.18189 12.3349 5.2754 11.4933 5.40007 11.3998C5.49358 11.2751 6.33517 11.1816 7.27026 11.1816H8.92226V13.0518ZM49.3807 11.5557C49.5989 11.7738 49.7547 12.6154 49.7547 13.4258V14.922H47.8845H46.0143V13.0518V11.1816H47.5105C48.3209 11.1816 49.1625 11.3375 49.3807 11.5557ZM28.1229 19.9403C32.736 22.8703 36.6946 25.4886 36.9127 25.7691C37.5985 26.673 37.692 27.7328 37.2244 28.7614C36.8504 29.5406 34.949 30.8809 28.2787 35.12C19.0213 41.0111 18.7096 41.1358 16.9641 39.5773L15.9355 38.6734V27.5458V16.4181L16.9641 15.5142C17.5563 14.9843 18.3355 14.6103 18.8343 14.6103C19.4265 14.6103 22.3876 16.2935 28.1229 19.9403ZM8.92226 18.8182V20.5326H7.05207H5.18189V18.8182V17.1039H7.05207H8.92226V18.8182ZM49.7547 18.8182V20.5326H47.8845H46.0143V18.8182V17.1039H47.8845H49.7547V18.8182ZM8.92226 24.5846V26.4548H7.05207H5.18189V24.5846V22.7144H7.05207H8.92226V24.5846ZM49.7547 24.5846V26.4548H47.8845H46.0143V24.5846V22.7144H47.8845H49.7547V24.5846ZM8.92226 30.5069V32.3771H7.05207H5.18189V30.5069V28.6367H7.05207H8.92226V30.5069ZM8.92226 36.4292V38.2993H7.05207H5.18189V36.4292V34.559H7.05207H8.92226V36.4292ZM8.92226 42.1956V43.9411L7.14558 43.8476L5.33773 43.7541L5.24423 42.1021L5.15072 40.4812H7.0209H8.92226V42.1956Z" fill="#7900F8" />
                                                        <path d="M44.1451 28.6675C40.6853 29.3532 37.6618 31.7533 36.1033 35.1196C35.3552 36.6781 35.2617 37.2703 35.2617 40.1691C35.2617 43.1926 35.3241 43.5978 36.2592 45.5303C38.1917 49.6136 41.3398 51.6708 46.0465 51.9513C48.2595 52.076 49.1634 51.9825 51.0336 51.4214C52.9973 50.798 53.5584 50.4551 55.2104 48.8031C57.8287 46.1849 58.6079 44.2212 58.6079 40.1691C58.6079 37.582 58.5144 36.9586 57.7663 35.3378C56.5819 32.813 55.6156 31.5974 53.7142 30.3506C51.1271 28.6363 47.5114 28.0129 44.1451 28.6675ZM49.8492 35.1819C51.1583 37.0521 52.3428 38.7976 52.4674 39.0782C52.7168 39.7639 52.0622 40.1691 50.7843 40.1691H49.7557V44.1588C49.7557 46.8395 49.631 48.2733 49.3816 48.5226C49.0076 48.8967 45.5166 49.0525 44.6438 48.7096C44.2075 48.5538 44.1451 47.8681 44.1451 44.377V40.2003L42.836 40.1068C41.8697 40.0444 41.4645 39.8574 41.4022 39.4834C41.2775 38.7665 46.2958 31.7533 46.9192 31.7533C47.1998 31.7533 48.5089 33.3118 49.8492 35.1819Z" fill="#7900F8" />
                                                    </svg>

                                                    <h4 className="title font-bold">Upload video file</h4>
                                                </Box>
                                            </ListItem>
                                        </List>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={6}
                                        lg={6}
                                    >
                                        <List
                                            className={clsx(
                                                classes.bgwhite,
                                                classes.borderRadius
                                            )}
                                            style={{
                                                border:
                                                    selectedCategory === "Embed"
                                                        ? "3px solid " +
                                                        theme.palette
                                                            .primary.main
                                                        : "1px solid #E1E1E1",
                                            }}
                                            onClick={() => {
                                                setSelectedCategory("Embed");
                                            }}
                                        >
                                            <ListItem>
                                                <Box width="100%" display={"flex"} flexDirection="column" justifyContent="space-between" alignItems={"center"}>


                                                    <svg width="56" height="61" viewBox="0 0 56 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M13.6421 0.456242C11.1359 0.883068 8.76094 1.86806 6.71435 3.32366C5.57614 4.13354 3.80316 5.90652 2.99328 7.04473C1.70184 8.85055 0.694965 11.1707 0.213415 13.4253C-0.0711382 14.7605 -0.0711382 18.5582 0.213415 19.8824C1.67996 26.7117 7.10835 31.8555 13.9376 32.8515C14.8679 32.9828 15.8529 33.0156 18.4795 32.9937L21.8285 32.9609L22.31 32.6326C23.7875 31.5819 23.6562 29.3383 22.0583 28.5285C21.6753 28.3315 21.4126 28.3096 19.2018 28.3096C14.9773 28.3096 13.467 28.0797 11.497 27.1604C10.2275 26.5694 9.29721 25.9456 8.34505 25.0372C4.61304 21.4803 3.63899 16.0081 5.92636 11.4553C7.26157 8.80677 9.80065 6.58507 12.5367 5.6548C14.0799 5.14042 14.638 5.07475 18.3153 5.00908L21.8285 4.94342L22.31 4.61509C23.7875 3.56443 23.6562 1.32084 22.0583 0.510963C21.6643 0.30302 21.4235 0.292076 18.0527 0.30302C15.6778 0.313965 14.1893 0.357742 13.6421 0.456242Z" fill="#7900F8" />
                                                        <path d="M33.9414 0.467209C32.2888 1.36465 32.1355 3.54257 33.6459 4.61511L34.1274 4.94344L37.6953 5.00911C41.4163 5.08572 41.876 5.14044 43.3973 5.65483C46.1552 6.58509 48.6834 8.79585 50.0295 11.4553C52.897 17.1683 50.5439 24.1398 44.7763 27.0182C42.7516 28.036 41.7994 28.2002 37.6624 28.2768C34.6856 28.3315 34.2259 28.3643 33.8757 28.5394C32.2888 29.3384 32.1684 31.582 33.6459 32.6326L34.1274 32.9609H37.9689C41.5367 32.95 41.8979 32.939 42.9376 32.7092C49.4714 31.2865 54.2978 26.4491 55.7315 19.8825C56.027 18.5582 56.027 14.7715 55.7425 13.4253C55.2609 11.1708 54.254 8.85057 52.9626 7.04475C52.1527 5.90654 50.3798 4.13356 49.2415 3.32368C47.4795 2.07603 45.214 1.06915 42.9704 0.554764C41.7447 0.281158 34.4339 0.204548 33.9414 0.467209Z" fill="#7900F8" />
                                                        <path d="M19.9336 14.4859C18.281 15.3505 18.1277 17.5503 19.6381 18.6228L20.1196 18.9512H27.9776H35.8357L36.3172 18.6228C37.7947 17.5722 37.6634 15.3286 36.0655 14.5187C35.6606 14.3108 35.3979 14.2998 27.9557 14.2998C21.1703 14.3108 20.2181 14.3327 19.9336 14.4859Z" fill="#7900F8" />
                                                    </svg>


                                                    <h4 className="title font-bold">Paste video file</h4>
                                                </Box>

                                            </ListItem>
                                        </List>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box
                                display={"flex"}
                                justifyContent="space-between"
                                className="my-4 py-4 pr-0 mr-0"
                            >
                                <Button
                                    variant="contained"
                                    color="default"
                                    onClick={() => history("/")}
                                >
                                    Previous
                                </Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    disabled={IsNullOrEmpty(selectedCategory)}
                                    onClick={() => {
                                        if (selectedCategory === "ScreenSharing" || selectedCategory === "Recording") {
                                            setMode("recording");
                                        }
                                        else {
                                            setMode("upload");
                                        }
                                    }}
                                >
                                    Next
                                </Button>
                            </Box>
                        </Box> :
                            mode === "upload" ? <InstantUpload category={selectedCategory} onClose={() => setMode("")} /> :
                                <InstantRecording category={selectedCategory} onClose={() => setMode("")} />
                    }
                </Grid>
                {
                    mode === "" && <Grid item xs={12} sm={12} lg={4} md={4}>
                        <Hidden implementation="js" only={["xs", "sm", "md"]}>
                            <Box className="side-image-box">
                                <img
                                    src={pic1}
                                    className="img-responsive rounded-xl"
                                />
                            </Box>
                        </Hidden>
                    </Grid>
                }
            </Grid>
        </main >
    );
}
